module.exports = __webpack_public_path__ + "img/logo-ncxz.049fb0d6.jpg";